import { authAPI } from './api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL?.replace('/api', '');

export const complaintsAPI = {
  /**
   * Get all complaints for the current user
   * @returns {Promise<Array>} Array of complaints
   */
  getComplaints: async () => {
    try {
      const currentUser = authAPI.getCurrentUser();
      if (!currentUser) {
        throw new Error('Nincs bejelentkezett felhasználó');
      }

      const clientUserId = currentUser.user_id || currentUser.id;
      const response = await fetch(`${API_BASE_URL}/complaints/api/list?client_user_id=${clientUserId}`);

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Expected JSON but received:', text.substring(0, 200));
        throw new Error('A szerver nem JSON választ küldött. Ellenőrizze az API endpoint-ot.');
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.message || 'Hiba a reklamációk lekérésekor');
      }
    } catch (error) {
      console.error('Get complaints error:', error);
      throw error;
    }
  },

  /**
   * Get a specific complaint with messages
   * @param {number} complaintId - ID of the complaint
   * @returns {Promise<Object>} Complaint details with messages
   */
  getComplaint: async (complaintId) => {
    try {
      const currentUser = authAPI.getCurrentUser();
      if (!currentUser) {
        throw new Error('Nincs bejelentkezett felhasználó');
      }

      const clientUserId = currentUser.user_id || currentUser.id;

      const response = await fetch(
        `${API_BASE_URL}/complaints/api/view?client_user_id=${clientUserId}&complaint_id=${complaintId}`
      );

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Expected JSON but received:', text.substring(0, 200));
        throw new Error('A szerver nem JSON választ küldött. Ellenőrizze az API endpoint-ot.');
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.message || 'Hiba a reklamáció lekérésekor');
      }
    } catch (error) {
      console.error('Get complaint error:', error);
      throw error;
    }
  },

  /**
   * Send a message to a complaint
   * @param {number} complaintId - ID of the complaint
   * @param {string} message - Message content
   * @returns {Promise<Object>} API response
   */
  sendMessage: async (complaintId, message) => {
    try {
      const currentUser = authAPI.getCurrentUser();
      if (!currentUser) {
        throw new Error('Nincs bejelentkezett felhasználó');
      }

      if (!message || message.trim() === '') {
        throw new Error('Az üzenet nem lehet üres');
      }

      const clientUserId = currentUser.user_id || currentUser.id;

      const requestData = {
        client_user_id: clientUserId,
        complaint_id: complaintId,
        message: message.trim()
      };

      const response = await fetch(`${API_BASE_URL}/complaints/api/send-message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Expected JSON but received:', text.substring(0, 200));
        throw new Error('A szerver nem JSON választ küldött. Ellenőrizze az API endpoint-ot.');
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.message || 'Hiba az üzenet küldésekor');
      }
    } catch (error) {
      console.error('Send message error:', error);
      throw error;
    }
  },

  /**
   * Create a new complaint
   * @param {string} title - Title of the complaint
   * @param {string} description - Description of the complaint
   * @returns {Promise<Object>} API response
   */
  createComplaint: async (title, description) => {
    try {
      const currentUser = authAPI.getCurrentUser();
      if (!currentUser) {
        throw new Error('Nincs bejelentkezett felhasználó');
      }

      if (!title || title.trim() === '') {
        throw new Error('A tárgy megadása kötelező');
      }

      if (!description || description.trim() === '') {
        throw new Error('A leírás megadása kötelező');
      }

      const clientUserId = currentUser.user_id || currentUser.id;

      const requestData = {
        client_user_id: clientUserId,
        title: title.trim(),
        description: description.trim()
      };

      const response = await fetch(`${API_BASE_URL}/complaints/api/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Expected JSON but received:', text.substring(0, 200));
        throw new Error('A szerver nem JSON választ küldött. Ellenőrizze az API endpoint-ot.');
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.message || 'Hiba a reklamáció létrehozásakor');
      }
    } catch (error) {
      console.error('Create complaint error:', error);
      throw error;
    }
  },

};

export default complaintsAPI;